module.exports = __webpack_public_path__ + "static/bg02-544d0e9c6c7846a93b5c74a93a24a010.jpg";